<template>
  <v-container fluid>
    <v-row justify="center" class="mx-0">
      <v-col cols="12" md="8" class="d-flex" style="flex-direction: column">
        <v-card outlined class="flex-grow-1">
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" sm="8">
                <BusinessCardRotator
                  :cardCorners="businessProfile.cardCorners"
                  :logoFrame="businessProfile.logoFrame"
                  :logoImageURL="businessProfile.logoImageURL"
                  :reverseImageURL="businessProfile.reverseImageURL"
                  :backgroundImageURL="businessProfile.backgroundImageURL"
                  :animatedEntry="true"
                />
              </v-col>

              <!--                     
                    
                    <v-col class="mx-2 mt-n4">
                      <v-list
                        flat
                        subheader
                      >
                        <v-subheader class="title font-weight-light text--primary">Optional Upgrades</v-subheader>

                        <v-list-item-group
                          v-model="selectedOptionalUpgrades"
                          multiple
                          active-class=""
                        >
                          <v-list-item v-for="optionalUpgrade in optionalUpgrades" :key="optionalUpgrade">
                            <template v-slot:default="{ active }">
                              <v-list-item-action>
                                <v-checkbox :input-value="active"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-light">{{optionalUpgrade}}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                      <v-btn v-if="selectedOptionalUpgrades.length > 0" class="mt-2" large block color="primary" elevation="0">Request Upgrade</v-btn>
                  </v-col>

 -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" class="d-flex" style="flex-direction: column">
        <v-card outlined>
          <v-card-text>
            <v-list-item two-line class="pa-0">
              <div class="v-list-item-content--left-item-width">
                <v-list-item-content class="pt-0">
                  <v-list-item-title class="font-weight-light title mb-2">{{
                    planName
                  }}</v-list-item-title>
                  <v-list-item-subtitle
                    class="subheading font-weight-light grey--text"
                    >{{
                      renderSubscriptionCardSubtitle()
                    }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </div>
            </v-list-item>
            <v-divider class="mb-2"></v-divider>
            <template v-if="isPartnerRepresentative()">
              <span class="caption grey--text font-weight-light">
                Annual Cost: $0*
              </span>
              <br/>
              <span class="caption grey--text font-weight-light">
                * Your subscription is currently complimentary
              </span>
            </template>
            <template v-else>
              <v-icon class="mr-2" small> event </v-icon>
              <span class="caption grey--text font-weight-light"
                >Next charge on
                {{
                  formatDate(businessProfile.nextInvoiceCreationDate.toDate())
                }}</span
              >
            </template>
          </v-card-text>
        </v-card>
        <div class="mb-4 flex-grow-1"></div>
        <v-card outlined>
          <v-card-text class="pt-2">
            <v-list-item two-line class="pa-0">
              <div class="v-list-item-content--left-item-width">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-light title mb-2"
                    >Active Users</v-list-item-title
                  >
                  <!-- <v-list-item-subtitle class="subheading font-weight-light grey--text">Monthly active users</v-list-item-subtitle> -->
                </v-list-item-content>
              </div>
              <v-list-item-content class="pt-0">
                <v-list-item-title
                  align="right"
                  class="font-weight-light display-1 text--secondary"
                  >{{ noOfActiveCardHolders }}</v-list-item-title
                >
                <v-list-item-subtitle align="right"
                  >&nbsp;</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <v-progress-linear
              class="mb-2"
              rounded
              :value="
                (noOfActiveCardHolders / businessProfile.noOfEmployees) * 100
              "
            ></v-progress-linear>
            <v-divider class="mb-2"></v-divider>
            <v-icon class="mr-2" small> mdi-clock </v-icon>
            <span class="caption grey--text font-weight-light"
              >last updated a few seconds ago</span
            >
          </v-card-text>
        </v-card>
        <div class="mb-4 flex-grow-1"></div>

        <v-row>
          <v-col class="py-0 d-flex" style="flex-direction: column">
            <v-card outlined class="flex-grow-1">
              <v-card-text>
                <div class="font-weight-light display-1 mb-2">
                  {{ noOfIosUsers }}
                </div>
                <div class="subheading font-weight-light grey--text">
                  <v-icon class="mr-2 mt-n2"> mdi-apple </v-icon>iOS users
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="py-0 d-flex" style="flex-direction: column">
            <v-card outlined class="flex-grow-1">
              <v-card-text>
                <div class="font-weight-light display-1 mb-2">
                  {{ noOfAndroidUsers }}
                </div>
                <div class="subheading font-weight-light grey--text">
                  <v-icon class="mr-2"> mdi-android </v-icon>
                  Android&nbsp;users
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12" md="4">
        <v-card
          outlined
          height="235"
          class="d-flex align-center flex-column justify-center"
        >
          <v-card-text class="text-center">
            <v-icon color="secondary" size="40" class="mb-5">group</v-icon>
            <div class="text-h5 font-weight-bold primary--text">
              {{ noOfCardHolders }}
            </div>
            <div class="text-subtitle">Team Members</div>

            <!-- <CircularGauge iconText="group" :chartValue="noOfCardHolders" :maxLimit="businessProfile.noOfEmployees" label="Team Members"/> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          outlined
          height="235"
          class="d-flex align-center flex-column justify-center"
        >
          <v-card-text class="text-center">
            <!-- <CircularGauge
                iconText="share"
                :chartValue="noOfConnections"
                :maxLimit="businessProfile.noOfEmployees * 1000"
                label="Connections"
              /> -->

            <v-icon color="secondary" size="40" class="mb-5">share</v-icon>
            <div class="text-h5 font-weight-bold primary--text">
              {{ noOfConnections }}
            </div>
            <div class="text-subtitle">Connections</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined height="235">
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12">
                <v-row justify="center" align="center">
                  <img src="../assets/logo-large.png" height="54" width="54" />
                </v-row>
                <p
                  class="text-center mt-2 title font-weight-light text--primary"
                >
                  Get In Touch
                </p>
                <p
                  class="
                    text-center
                    mt-n4
                    subheading
                    font-weight-light
                    grey--text
                  "
                >
                  Have a question or want to provide feedback?
                </p>
                <v-row justify="center" align="center">
                  <v-btn
                    outlined
                    width="250"
                    color="primary"
                    href="https://pappyon.com/contact/"
                    large
                    elevation="0"
                    >Contact Us</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// @ is an alias to /src
import BusinessCardRotator from "@/components/BusinessCardRotator";
import CircularGauge from "@/components/CircularGauge";
import { mapGetters } from "vuex";
import Utility from "@/shared/utility";

export default {
  name: "Dashboard",
  created() {
    this.formatDate = Utility.formatDate;
    this.getSubscriptionPlanTitle = Utility.getSubscriptionPlanTitle;
    console.log("Dashboard created");
  },
  components: {
    BusinessCardRotator,
    CircularGauge,
  },
  computed: {
    ...mapGetters([
      "businessProfile",
      "noOfCardHolders",
      "noOfActiveCardHolders",
      "noOfConnections",
      "noOfIosUsers",
      "noOfAndroidUsers",
    ]),
    planName() {
      // return this.getSubscriptionPlanTitle(this.businessProfile.plan);
      return "Pappyon for Business";
    },
  },
  data() {
    return {
      selectedOptionalUpgrades: [],
      optionalUpgrades: ["CRM Integration", "Bespoke Card Design"], //'Industry Specific Profile'],
      quickLinks: [
        {
          title: "View Notifications",
          icon: "notifications_active",
          iconClass: "pink lighten-2 white--text",
          to: "/notifications",
        },
        {
          title: "Manage your Team",
          icon: "people",
          iconClass: "light-green white--text",
          to: "/cardholders",
        },
        {
          title: "Update your Card",
          icon: "crop_16_9",
          iconClass: "amber lighten-2 white--text",
          to: "/manageCard",
        },
        {
          title: "Manage your Subscription",
          icon: "settings",
          iconClass: "light-blue lighten-2 white--text",
          to: "/subscription",
        },
        {
          title: "Access Control",
          icon: "settings",
          iconClass: "light-blue lighten-2 white--text",
          to: "/administration",
        },
        // { title: 'Get Support', icon: 'help', iconClass: 'purple lighten-2 white--text', to: '/support'}
      ],
    };
  },
  methods: {
    isPartnerRepresentative() {
      if (this.businessProfile.partnerRepresentativeToken) {
        return true;
      } else {
        return false;
      }
    },
    renderSubscriptionCardSubtitle() {
      let subscriptionStatus = this.businessProfile.subscriptionStatus || "";
      if (this.isPartnerRepresentative()) {
        let businessProfileCreationDate = this.businessProfile.creationDate.toDate();
        let oneYearLater = new Date(businessProfileCreationDate.getFullYear() + 1, businessProfileCreationDate.getMonth(), businessProfileCreationDate.getDate());
        return `Subscription Period: ${this.formatDate(businessProfileCreationDate)} to ${this.formatDate(oneYearLater)}`;
      }
      else if (subscriptionStatus == "trialing")
        return (
          (this.businessProfile.trialPeriodDays || "30") +
          " Day Free Trial Period"
        );
      else if (this.businessProfile.billingPeriod == "yearly")
        return "Yearly Subscription";
      else return "Monthly Subscription";
    },
  },
};
</script>
